<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800px">
    <template v-slot:title>Add Route</template>
    <template v-slot:top>
      <v-container fluid pb-0>
        <v-row align="center" justify="center" dense>
          <v-col cols="12" sm="10" class="pb-0">
            <v-text-field
              label="Filter"
              v-model="search"
              :outlined="outlinedInputs"
              dense
              class="ma-0"
              append-icon="mdi-magnify"
              single-line
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <v-card outlined>
      <v-data-table
        :items="items"
        :headers="headers"
        :search="search"
        v-model="selectedRoutes"
        show-select
        single-select
        :loading="$apollo.loading"
      ></v-data-table>
    </v-card>
    <v-row v-if="debug">
      <v-col>
        selected
        <code>{{ selectedRoutes }} - {{ routes }}</code>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn
        color="primary"
        :disabled="selectedRoutes.length == 0"
        @click="onAdd"
        >Add</v-btn
      >
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog";
import gql from "graphql-tag";
const ROUTES_QUERY = gql`
  query gtRoutes {
    routes: gtRoutes {
      edges {
        node {
          id
          name
          code
          description
          coordinates
          tags
          color
        }
      }
    }
  }
`;

export default {
  name: "add-route-dialog",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      search: "",
      selectedRoutes: [],
      headers: [
        {
          text: "Name",
          sortable: false,
          value: "name",
          name: "name",
        },
        {
          text: "Code",
          sortable: false,
          value: "code",
          name: "code",
        },
        {
          text: "Tags",
          sortable: false,
          value: "tags",
          name: "tags",
        },
        {
          text: "Description",
          sortable: false,
          value: "description",
          name: "description",
        },
      ],
    };
  },

  watch: {
    show(newVal) {
      this.selectedRoutes = [];
      this.search = "";
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    items() {
      return this.routes && this.routes.edges
        ? this.routes.edges.map((r) => ({ ...r.node }))
        : [];
    },
  },

  methods: {
    onAdd() {
      const selectedRoute = this.selectedRoutes[0];
      this.$emit("create", { ...selectedRoute });
    },
  },

  apollo: {
    routes: {
      query: ROUTES_QUERY,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/routes/AddRouteDialog.vue